import SentryGraphQLError from "@/helpers/exceptions/SentryGraphQLError";
import graphqlClient from "@/GQLClient";
import type { FetchPolicy } from "@apollo/client";
import { GetShiftsQueryDocument } from "@/graphql/generated-types";
import {
  ScheduleAvailableEmployeesDocument,
  type ScheduleAvailableEmployee,
} from "@/graphql/generated-types";
import type { WSShiftFragment } from "@/graphql";
import { format, formatISO } from "date-fns";

const getAvailableEmployees = async (
  dateFrom: Date,
  dateTo: Date,
): Promise<ScheduleAvailableEmployee[]> => {
  const response = await graphqlClient.query({
    query: ScheduleAvailableEmployeesDocument,
    fetchPolicy: "no-cache",
    variables: {
      filter: {},
      dateFrom: formatISO(dateFrom),
      dateTo: formatISO(dateTo),
    },
  });

  if (response.data.scheduleAvailableEmployees) {
    return response.data.scheduleAvailableEmployees;
  }

  throw new SentryGraphQLError("workSchedule.getAvailableEmployees");
};

const getShifts = async (
  departmentId: string,
  fetchPolicy: FetchPolicy = "no-cache",
): Promise<WSShiftFragment[]> => {
  const today = new Date();
  const response = await graphqlClient.query({
    query: GetShiftsQueryDocument,
    fetchPolicy,
    variables: {
      dateFrom: format(today, "yyyy-MM-dd"),
      dateTo: format(today, "yyyy-MM-dd"),
      timezone: new window.Intl.DateTimeFormat().resolvedOptions().timeZone,
      filter: {
        departments: [departmentId],
      },
    },
  });

  if (response.data.schedule?.shifts) {
    return response.data.schedule.shifts;
  }

  throw new SentryGraphQLError("workSchedule.getShifts");
};

export default {
  getAvailableEmployees,
  getShifts,
};
